module.exports = __webpack_public_path__ + "img/PS01.02384669.png";